export const USERS_QUERY_KEYS = {
  WORKSPACE_IDS: 'workspaceIds',
  GROUP_IDS: 'groupIds',
  ACCOUNT_IDS: 'accountIds',
  ROLE_IDS: 'roleIds',
  PLATFORM_IDS: 'platformIds'
}
